import { PropsWithChildren } from 'react';
import { TooltipTrigger } from '../ui/tooltip';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
} from '@radix-ui/react-tooltip';

interface StyledTooltipContainerProps {
  tooltipMessage: string;
  tooltipMessageAriaLabel?: string;
  tooltipItemAriaLabel?: string;
  asChild?: boolean;
}

const StyledTooltipContainer = ({
  tooltipMessage,
  tooltipItemAriaLabel,
  tooltipMessageAriaLabel,
  children,
  asChild = false,
}: PropsWithChildren<StyledTooltipContainerProps>) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger
          className="max-w-72 xl:max-w-96 inline-block overflow-hidden whitespace-nowrap text-ellipsis"
          aria-label={tooltipItemAriaLabel}
          asChild={asChild}
        >
          {children}
        </TooltipTrigger>
        <TooltipContent
          className="bg-gray-800 text-white text-sm px-2 py-1 rounded shadow-lg"
          aria-label={tooltipMessageAriaLabel}
        >
          {tooltipMessage}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default StyledTooltipContainer;
